/**
 * Write-off photos, kept on the phone (IndexedDB) until server sync exists. A photo is evidence,
 * never a requirement: every failure here resolves quietly so a write-off is never blocked.
 */
const DB = "rotations-photos";
const STORE = "photos";

function open(): Promise<IDBDatabase | null> {
  return new Promise((resolve) => {
    try {
      const req = indexedDB.open(DB, 1);
      req.onupgradeneeded = () => req.result.createObjectStore(STORE);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => resolve(null);
    } catch {
      resolve(null);
    }
  });
}

/** Saves the photo and returns its id, or null when the phone couldn't store it. */
export async function savePhoto(blob: Blob): Promise<string | null> {
  const db = await open();
  if (!db) return null;
  const id = `photo-${crypto.randomUUID().slice(0, 12)}`;
  return new Promise((resolve) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(blob, id);
    tx.oncomplete = () => resolve(id);
    tx.onerror = () => resolve(null);
  });
}

export async function loadPhoto(id: string): Promise<Blob | null> {
  const db = await open();
  if (!db) return null;
  return new Promise((resolve) => {
    const req = db.transaction(STORE).objectStore(STORE).get(id);
    req.onsuccess = () => resolve((req.result as Blob | undefined) ?? null);
    req.onerror = () => resolve(null);
  });
}
